import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface AppIconProps {
    className?: string
}

const AppIcon: FC<AppIconProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 48 48'
            aria-hidden='true'
            focusable='false'
            className={cn('size-10 shrink-0', className)}
        >
            <rect width='48' height='48' rx='12' fill='#0b1324' />
            <rect width='47' height='47' x='0.5' y='0.5' rx='11.5' fill='none' stroke='#ffffff' strokeOpacity='0.1' />
            <rect x='9' y='9' width='13.5' height='13.5' rx='3.6' fill='#f43f5e' />
            <rect x='25.5' y='9' width='13.5' height='13.5' rx='3.6' fill='#6366f1' />
            <rect x='9' y='25.5' width='13.5' height='13.5' rx='3.6' fill='#f59e0b' />
            <rect x='25.5' y='25.5' width='13.5' height='13.5' rx='3.6' fill='#10b981' />
            <path d='M12 0h24a12 12 0 0 1 12 12v6C34 22 14 22 0 18v-6A12 12 0 0 1 12 0Z' fill='#ffffff' fillOpacity='0.08' />
        </svg>
    )
}

export default AppIcon
